import {
  APP_INITIALIZER,
  ApplicationConfig,
  importProvidersFrom,
  provideBrowserGlobalErrorListeners,
  provideZonelessChangeDetection,
} from "@angular/core";
import { provideRouter } from "@angular/router";

import { routes } from "./app.routes";

import { provideHttpClient, withInterceptors } from "@angular/common/http";
import { provideAnimationsAsync } from "@angular/platform-browser/animations/async";
import { NgbModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { InlineSVGModule } from "ng-inline-svg-2";
import { ClipboardModule } from "ngx-clipboard";
import { SharedModule } from "src/shared/shared.module";
import { AuthService } from "./pages/auth";
import { appInitializer } from "src/utils/app-intialization";
import { httpClientInterceptor } from "src/utils/http-client.intercepter";
import { provideSweetAlert2 } from "@sweetalert2/ngx-sweetalert2";
import { NgxPermissionsService, NgxPermissionsModule } from "ngx-permissions";

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZonelessChangeDetection(),
    provideRouter(routes),
    // provideClientHydration(withEventReplay()),

    // ✅ animations
    provideAnimationsAsync(),

    provideSweetAlert2(),

    // ✅ http client
    provideHttpClient(withInterceptors([httpClientInterceptor])),

    // ✅ translate, clipboard, svg, ng-bootstrap, sweetalert2, shared
    importProvidersFrom(
      TranslateModule.forRoot(),
      ClipboardModule,
      InlineSVGModule.forRoot(),
      NgxPermissionsModule.forRoot(),
      NgbModule,
      SharedModule
    ),
    // ✅ app initializer
    {
      provide: APP_INITIALIZER,
      useFactory: appInitializer,
      deps: [AuthService],
      multi: true,
    },
  ],
};
